import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=634caa47&scoped=true"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"
import style0 from "./ThemeToggle.vue?vue&type=style&index=0&id=634caa47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634caa47",
  null
  
)

export default component.exports